import { combineReducers } from 'redux'

import languageReducer from './languageReducer'
import regionsReducer from './regionsReducer'
import indicatorsReducer from './indicatorsReducer'
import filtersReducer from './filtersReducer'

export default combineReducers({
  LANGUAGE: languageReducer,
  REGIONS: regionsReducer,
  INDICATORS: indicatorsReducer,
  FILTERS: filtersReducer
})



// WEBPACK FOOTER //
// ./src/redux/Reducers/mainReducer.js